import React from 'react'
import styled from 'styled-components'
import LoaderBase from 'react-loader-spinner'
import { useSelector } from 'react-redux'

import TimeAgo from 'components/TimeAgo'
import { formatDate, formatDateTime } from 'utils/dateUtils'
import {
  rfpMetaSelector,
  isSubmittingLaneSelector,
  proposalRateTypeSelector,
  hasProposalSelector,
} from 'features/carrierProposal/selectors'
import {
  Button,
  Container,
  DateWrapper,
  Group,
  Name,
  LastSaved,
} from './styles'

const Loader = styled(LoaderBase)`
  display: flex;
  justify-content: center;
  align-items: center;
`
const RateType = styled.div`
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.backgroundSecondary};
  display: flex;
  font-size: 14px;
  height: 33px;
  line-height: 16px;
  padding: 0 20px;
`

interface Props {
  name: string
  startDate: string
  endDate: string
  submittedAt: string | undefined
  canReceiveProposals: boolean
  submit(): void
}

export default function Contract({
  name,
  startDate,
  endDate,
  submittedAt,
  canReceiveProposals,
  submit,
}: Props) {
  const proposalRateType = useSelector(proposalRateTypeSelector)
  const rfpMeta = useSelector(rfpMetaSelector)
  const isSubmittingLane = useSelector(isSubmittingLaneSelector)
  const hasProposals = useSelector(hasProposalSelector)
  const isDisabled =
    !!submittedAt ||
    rfpMeta.isSubmitting ||
    !canReceiveProposals ||
    !hasProposals

  return (
    <Container>
      <div>
        <Name>{name}</Name>
        <DateWrapper>
          Start: {formatDate(startDate)} - End: {formatDate(endDate)}
        </DateWrapper>
      </div>
      <Group>
        {submittedAt ? (
          <LastSaved>
            Offer submitted at {formatDateTime(submittedAt)}
          </LastSaved>
        ) : (
          <>
            <LastSaved>
              {isSubmittingLane && (
                <LoaderBase type="TailSpin" width={20} height={20} />
              )}
              {rfpMeta.lastSavedAt && (
                <>
                  &nbsp; Last saved&nbsp; <TimeAgo date={rfpMeta.lastSavedAt} />
                </>
              )}
            </LastSaved>
            {!!proposalRateType && <RateType>{proposalRateType}</RateType>}
            <Button disabled={isDisabled} onClick={submit}>
              {rfpMeta.isSubmitting ? (
                <Loader width={20} height={20} type="Oval" />
              ) : (
                <>Submit Offer</>
              )}
            </Button>
          </>
        )}
      </Group>
    </Container>
  )
}
